<template>
    <b-row no-gutters
           id="start_packet_footer_component"
           class="start-packet-footer-component">
        <b-col lg="12" class="start-packet-footer-element">
            <ul class="start-packet-footer-list">
                <li class="start-packet-footer-item">
                    <router-link :to="{ name: 'MarketingPlan' }">
                        <span v-html="text"></span>
                    </router-link>
                </li>
            </ul>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        dependencies: ['careerLevel'],
        data() {
            return {
                defaultText: 'Do you need more information?<br>\n' +
                '             Check out FuturoNetwork Marketing Plan'
            }
        },
        props: ['customText'],
        beforeMount () {
            this.careerLevel.fetchData()
        },
        computed: {
            text() {
                return this.customText ? this.customText : this.defaultText
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .start-packet-footer-list{
        position: relative;
        list-style-type: none;
        padding: 10px 0;

        &:before{
            position: absolute;
            content: "";
            left: 0;
            top: 0;
            width: 30px;
            height: 2px;
            background-color: $base1;
        }
    }

    .start-packet-footer-item{

        a{
            font-weight: bold;
            color: $base2;
        }
    }

    @media(max-width:991px){
        .start-packet-footer-element{
            margin-top: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/start-packet/StartPacketFooter.vue